<div #wrapper class="wrapper" style="height: 100%;">
    <div class="modal-header-wrapper">
        <div class="text-wrapper" [class.font-weight-600]="true">Възстановяване на потребител</div>
        <div class="responsive-flex-wrapper shortcuts">
            <i class="ti-close" (click)="onClose()"></i>
        </div>
    </div>

    <ng-container>
        <div class="modal-body">
            <div class="form-block">
                <form class="pt-3" [formGroup]="recoveryForm">
                    <div class="form-group">
                        <label class="font-weight-bold">Имейл:</label>
                        <input type="email" name="email" class="form-control form-control-lg" formControlName="email" placeholder="Въведете имейл на потребителя">
                    </div>
                </form>

                <div class="clear"></div>

                <button type="button" class="btn btn-block btn-success filter-btn"
                        (click)="onRecover()" [disabled]="!recoveryForm.valid">Възстанови</button>
            </div>
        </div>
    </ng-container>
</div> 